<sc-scroll-pane>
  <sc-padding>
    <sc-flex vertical [gap]="16" stretchContent>
      @for (schedule of transportOption.limitSchedules; track schedule) {
        <app-transport-option-editor-limits-schedule [schedule]="schedule" (removeRequested)="removeLimitSchedule($event)"></app-transport-option-editor-limits-schedule>
      }
      <sc-flex centered>
        <sc-action-icon iconClass="fa-plus-circle fa-2x" (click)="addLimitSchedule()"></sc-action-icon>
        <sc-content-spacer></sc-content-spacer>
        <sc-dictionary-label
        dictionaryKey="tmc-yard.control.ui.transport-option-administration.add-limit-schedule"></sc-dictionary-label>
      </sc-flex>
    </sc-flex>
  </sc-padding>
</sc-scroll-pane>
